import OrderHandler from "../OrderHandler";
import ItemRow from "./ItemRow";
import Mediator from "../../../Utilities/Mediator";

export default class CartItems {
	total: number;
	spanTotal: HTMLSpanElement;

	constructor() {
		this.spanTotal = document.querySelector('.bill-total div:nth-child(3) span:last-child');

		this.init();
	}

	private init() {
		this.CreateCartItems();

		Mediator.on("itemCountChanged", (count, cost, oldCost) => {
			this.updatePriceTotal(count, cost, oldCost);
		});
	}

	private CreateCartItems() {
		const orderItems = document.getElementById("order-items");
		orderItems.innerHTML = "";
		this.total = 0;

		OrderHandler.order.items.forEach(item => {
			const itemRow = new ItemRow(item);
			const row = itemRow.createRow();
			this.total += itemRow.cost * item.count;
			orderItems.append(row);
		});

		this.spanTotal.innerHTML = `${this.total} DKK`;
	}

	private updatePriceTotal(count: number, cost: number, oldCost: number): void {
		this.total -= oldCost;
		this.total += count * cost;
		this.spanTotal.innerHTML = `${this.total.toFixed(2)} DKK`;
		if (OrderHandler.order.items.length == 0) {
			Mediator.emit("allItemsDeleted");
			this.spanTotal.innerHTML = '0 DKK';
		}
	}
}
